import React, { useContext } from "react";
import { Grid, makeStyles, Theme } from "@material-ui/core";
import { Locations } from "../../context";
import { LocationCard } from "../../components";

export const AllLocations = () => {
  const officeLocations = useContext(Locations);
  const classes = useStyles();
  return (
    <>
      <Grid container>
        {officeLocations.map((location) => {
          return (
            <Grid
              key={location.id}
              className={classes.column}
              item
              xs={12}
              sm={6}
              md={4}
            >
              <LocationCard
                location={location}
                hideViewMoreLocations={true}
                hideProviders={false}
                evenCards={true}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    padding: "1rem",
    color: theme.palette.primary.dark,
  },
  loading: {
    color: theme.palette.secondary.light,
    justifyContent: "space-around",
  },
  column: {
    padding: "1rem",
    margin: ".5rem 0",
  },
  locationFinder: {
    color: theme.palette.primary.dark,
  },
  search: {
    margin: "1rem 0",
  },
}));
